import React from 'react';
import { Box, Button } from '@material-ui/core';
import Image from './Image';
import OrderModal, { OrderButton } from './OrderModal';
import Alert from '../../preorder/components/Alert';

export const TAB_STATUS_MAP = {
  SELECTED: 'SELECTED',
  OVERDUE: 'OVERDUE',
  NORMAL: 'NORMAL',
};

const Template = ({
  text,
  items,
  itemTemplate: ItemTemplate,
}) => (
  <Box textAlign="left">
    <Box fontSize={22} fontWeight="bold" px={1}>{text}</Box>
    <Box>
      {items.map((props) => {
        const { provider: providerName } = props;
        return (
          <ItemTemplate {...props} key={`${text}-${providerName}`} />
        );
      })}
    </Box>
  </Box>
);

const CircularTab = ({ onClick, text, status = TAB_STATUS_MAP.NORMAL }) => {
  const styleMap = {
    [TAB_STATUS_MAP.OVERDUE]: {
      bgcolor: '#d8d8d8',
      color: '#ffffff',
    },
    [TAB_STATUS_MAP.SELECTED]: {
      bgcolor: '#000000',
      color: '#ffc821',
    },
    [TAB_STATUS_MAP.NORMAL]: {
      bgcolor: '#ffc821',
      color: '#000000',
    },
  };

  return (
    <Box
      alignItems="center"
      borderRadius="50%"
      display="flex"
      flexDirection="column"
      fontSize={{ xs: 12, sm: 16 }}
      fontWeight="bold"
      height={{ xs: 70, sm: 100 }}
      justifyContent="center"
      onClick={onClick}
      minWidth={{ xs: 70, sm: 100 }}
      width={{ xs: 70, sm: 100 }}
      style={{
        cursor: status === TAB_STATUS_MAP.OVERDUE ? 'default' : 'pointer',
      }}
      {...styleMap[status]}
    >
      <Box>{text}</Box>
      <Box>查看菜單</Box>
      <Box height={24} fontWeight="normal">
        {status === TAB_STATUS_MAP.OVERDUE ? '已截止' : ''}
      </Box>
    </Box>
  );
};

export default ({
  alert,
  creatingOrder,
  data,
  datesToDispaly,
  isAlertOpen,
  onAlertButtonClick,
  onDateClick,
  onOrderClick,
  onOrderModalClose,
  onOrderModalOrderButtonClick,
  orderModalData,
}) => (
  <Box width="100%">
    <OrderModal
      isOpen={creatingOrder}
      onClose={onOrderModalClose}
      onOrderButtonClick={onOrderModalOrderButtonClick}
      data={orderModalData}
    />
    <Alert
      isOpen={isAlertOpen}
      title={alert?.title || ''}
      content={alert?.message || ''}
      buttons={alert?.buttons || (
        <Button fullWidth onClick={onAlertButtonClick}>
          <Box fontWeight="fontWeightBold" color="support.main">
            確認
          </Box>
        </Button>
      )}
    />
    <Box fontSize={36}>早起訂便當 全新試營運</Box>
    <Box mt={2} fontSize={28}>\早鳥專享通通95折/</Box>
    <Box mt={2} fontSize={18} px={1}>每日09:30前預訂完成付款 ▶中午上架 ▶ 開門領取標注您手機末三碼的商品 ▶ 輕鬆開動</Box>
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      overflow="auto"
      mt={2}
      px={1}
    >
      {datesToDispaly.map((dateToDispaly) => {
        const { displayText, moment: displayMoment, status } = dateToDispaly || {};

        return (
          <CircularTab
            key={displayText}
            text={displayText}
            status={status}
            onClick={() => {
              if (status === TAB_STATUS_MAP.OVERDUE) return;
              onDateClick(displayMoment);
            }}
          />
        );
      })}
    </Box>
    <Box mt={2}>
      {
        ['主餐', '輕食', '甜點', '飲料']
          .map((type) => data.find(({ type: dataType }) => type === dataType))
          .filter((i) => i)
          .map(({ type, providers }) => (
            <Template
              key={type}
              text={type}
              items={providers}
              itemTemplate={({
                provider: providerName,
                introduction,
                products,
                images,
              }) => (
                <div className="dailymenu-provider" key={providerName}>
                  <Image urls={images} className="dailymenu-provider-image" />
                  <div className="dailymenu-provider-name">{providerName}</div>
                  <div className="dailymenu-provider-introduction">{introduction}</div>
                  {
                  products.map((product) => {
                    const {
                      name,
                      price,
                      calories = null,
                      isShowOrderButton,
                    } = product || {};
                    return (
                      <div className="dailymenu-provider-product" key={name}>
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                        >
                          <Box className="name">{name}</Box>
                          <Box display="flex" alignItems="center" flexShrink={0}>
                            <Box>優惠價</Box>
                            <Box className="price" float="none" flexShrink={0}>{price}</Box>
                            {isShowOrderButton
                            && (
                            <Box ml={2}>
                              <OrderButton
                                onClick={() => { onOrderClick(product); }}
                              >
                                訂購
                              </OrderButton>
                            </Box>
                            )}
                          </Box>
                        </Box>
                        {calories && <div className="calories">{`參考熱量：${calories}大卡`}</div>}
                      </div>
                    );
                  })
                }
                </div>
              )}
            />
          ))
      }
    </Box>
  </Box>
);
